import { useState, useEffect, useContext } from 'react'
import { NavLink, useNavigate } from "react-router-dom";
import Menu from '../../components/DashboardAdmin/Menu';
import AuthContext from '../../Context/auth';
import axios from 'axios';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Filler,
  Legend,
  RadialLinearScale,
  ArcElement
} from 'chart.js';
import { Line, Bar, PolarArea } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Filler,
  Legend,
  ArcElement,
  RadialLinearScale
);


let datetoday = new Date();
let daytodayFormat = datetoday.toISOString().split("T")[0];

let date1 = new Date();
date1.setDate(date1.getDate() - 1);
let day1Format = date1.toISOString().split("T")[0];

let date2 = new Date();
date2.setDate(date2.getDate() - 2);
let day2Format = date2.toISOString().split("T")[0];


let date3 = new Date();
date3.setDate(date3.getDate() - 3);
let day3Format = date3.toISOString().split("T")[0];


let date4 = new Date();
date4.setDate(date4.getDate() - 4);
let day4Format = date4.toISOString().split("T")[0];



let date5 = new Date();
date5.setDate(date5.getDate() - 5);
let day5Format = date5.toISOString().split("T")[0];



let date6 = new Date();
date6.setDate(date6.getDate() - 6);
let day6Format = date6.toISOString().split("T")[0];


function subtractMonth(date, months) {
  let d = date?.getDate();
  date?.setMonth(date?.getMonth() - months);
  if (date?.getDate() != d) {
    date?.setDate(0);
  }
  return date?.toISOString()?.split("T")?.[0]?.slice(0, -3);
}


let monthtoday = new Date();
let monthtodayFormat = monthtoday.toISOString().split("T")[0].slice(0, -3);

let month1 = new Date();
let month1Format = subtractMonth(month1, 1);

let month2 = new Date();
let month2Format = subtractMonth(month2, 2);

let month3 = new Date();
let month3Format = subtractMonth(month3, 3);

let month4 = new Date();
let month4Format = subtractMonth(month4, 4);

let month5 = new Date();
let month5Format = subtractMonth(month5, 5);

let month6 = new Date();
let month6Format = subtractMonth(month6, 6);

let month7 = new Date();
let month7Format = subtractMonth(month7, 7);

let month8 = new Date();
let month8Format = subtractMonth(month8, 8);

let month9 = new Date();
let month9Format = subtractMonth(month9, 9);

let month10 = new Date();
let month10Format = subtractMonth(month10, 10);

let month11 = new Date();
let month11Format = subtractMonth(month11, 11);



const Application = () => {

  const { Auth, setAuth } = useContext(AuthContext);
  let navigate = useNavigate();


  const [TotalClients, setTotalClients] = useState('')
  const [TotalClientsPerCat, setTotalClientsPerCat] = useState('')

  const [WhatsApp, setWhatsApp] = useState('')


  const [TotlaViewsPerDay, setTotlaViewsPerDay] = useState('')
  const [TotlaViewsPerMonth, setTotlaViewsPerMonth] = useState('')
  const [Mostvisitedhours, setMostvisitedhours] = useState('')
  const [MostvisitedDays, setMostvisitedDays] = useState('')


  const [DateSearch, setDateSearch] = useState(new Date().toISOString().split('T')[0])

  const DaysFr = {
    "Monday": "Lundi",
    "Tuesday": "Mardi",
    "Wednesday": "Mercredi",
    "Thursday": "Jeudi",
    "Friday": "Vendredi",
    "Saturday": "Samedi",
    "Sunday": "Dimanche"
  }


  const options = {
    // responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: false,
      title: {
        display: true,
        text: '# Commandes Par Jour',
      },
    },
  };

  const optionstwo = {
    // responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: false,
      title: {
        display: true,
        text: 'Commandes Par Mois',
      },
    },
  };

  const optionsthree = {
    // responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: false,
      title: {
        display: true,
        text: 'Horaires les plus visités',
      },
    },
  };

  const optionsfour = {
    // responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: false,
      title: {
        display: true,
        text: 'Jours les plus visités',
      },
    },
  };

  const labels = [day6Format, day5Format, day4Format, day3Format, day2Format, day1Format, daytodayFormat];

  const data = {
    labels,
    datasets: [
      {
        fill: true,
        label: 'Commandes',
        data: [TotlaViewsPerDay?._6day, TotlaViewsPerDay?._5day, TotlaViewsPerDay?._4day, TotlaViewsPerDay?._3day, TotlaViewsPerDay?._2day, TotlaViewsPerDay?._1day, TotlaViewsPerDay?.today],
        borderColor: 'rgb(53, 162, 235)',
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
      },
    ],
  };



  const labels2 = [month11Format, month10Format, month9Format, month8Format, month7Format, month6Format, month5Format, month4Format, month3Format, month2Format, month1Format, monthtodayFormat];

  // const data2 = {
  //   labels2,
  //   datasets: [
  //     {
  //       fill: true,
  //       label: 'Visiteurs Par Mois',
  //       data: [TotlaViewsPerMonth?.Months_11,TotlaViewsPerMonth?.Months_10,TotlaViewsPerMonth?.Months_9,TotlaViewsPerMonth?.Months_8,TotlaViewsPerMonth?.Months_7, TotlaViewsPerMonth?.Months_6, TotlaViewsPerMonth?.Months_5, TotlaViewsPerMonth?.Months_4, TotlaViewsPerMonth?.Months_3, TotlaViewsPerMonth?.Months_2, TotlaViewsPerMonth?.Months_1,TotlaViewsPerMonth?.Months],
  //       borderColor: '#f783ee',
  //       backgroundColor: '#ff6db678',
  //     },
  //   ],
  // };

  const data2 = {
    labels: labels2,
    datasets: [{
      label: 'Commandes',
      data: [TotlaViewsPerMonth?.Months_11, TotlaViewsPerMonth?.Months_10, TotlaViewsPerMonth?.Months_9, TotlaViewsPerMonth?.Months_8, TotlaViewsPerMonth?.Months_7, TotlaViewsPerMonth?.Months_6, TotlaViewsPerMonth?.Months_5, TotlaViewsPerMonth?.Months_4, TotlaViewsPerMonth?.Months_3, TotlaViewsPerMonth?.Months_2, TotlaViewsPerMonth?.Months_1, TotlaViewsPerMonth?.Months],
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(255, 159, 64, 0.2)',
        'rgba(255, 205, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(201, 203, 207, 0.2)'
      ],
      borderColor: [
        'rgb(255, 99, 132)',
        'rgb(255, 159, 64)',
        'rgb(255, 205, 86)',
        'rgb(75, 192, 192)',
        'rgb(54, 162, 235)',
        'rgb(153, 102, 255)',
        'rgb(201, 203, 207)'
      ],
      borderWidth: 1
    }]
  };


  const labels3 = [Mostvisitedhours?.[0]?.hour?.toString()?.padStart(2, "0") + ":00", Mostvisitedhours?.[1]?.hour?.toString()?.padStart(2, "0") + ":00", Mostvisitedhours?.[2]?.hour?.toString()?.padStart(2, "0") + ":00"];
  const data3 = {
    labels: labels3,
    datasets: [
      {
        type: 'line',
        fill: true,
        label: 'Commandes',
        data: [Mostvisitedhours?.[0]?.visitors, Mostvisitedhours?.[1]?.visitors, Mostvisitedhours?.[2]?.visitors],
        borderColor: '#ff6384',
        backgroundColor: "rgb(255 99 132 / 18%)",
        pointStyle: 'circle',
        pointRadius: 10,
        pointHoverRadius: 15
      },
    ],
  };


  const labels4 = [DaysFr?.[MostvisitedDays?.[0]?.day], DaysFr?.[MostvisitedDays?.[1]?.day], DaysFr?.[MostvisitedDays?.[2]?.day]];
  const data4 = {
    labels: labels4,
    datasets: [
      {
        type: 'polarArea',
        fill: true,
        label: 'Visiteurs',
        data: [MostvisitedDays?.[0]?.visitors, MostvisitedDays?.[1]?.visitors, MostvisitedDays?.[2]?.visitors],
        // borderColor: '#ff6384',
        backgroundColor: ["#7288dbb0", "#1b6b7694", "#5a559fa6"],
        // pointStyle: 'circle',
        // pointRadius: 10,
        // pointHoverRadius: 15
      },
    ],
  };




  // useEffect(() => {


  //   if (Auth) {
  //     console.log('hi!');

  //   }else{
  //     console.log('no!'); 
  //     return navigate("/");
  //   }


  // }, [Auth])

  const [MenuShow, setMenuShow] = useState(true)

  const [windowSize, setWindowSize] = useState(getWindowSize());


  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  console.log(windowSize);

  // const [MobileScreen, setMobileScreen] = useState(windowSize.innerWidth > 992 ? false : true)

  const ValidateToken = async (GetAllData) => {
    // setLoading(true)
    try {
      const { data: response } = await axios.post(`${process.env.REACT_APP_LOCAL_URL}/categorie/get_total_clients?ux=1${!GetAllData ? SearchPer == 1 ? '&date=' + DateSearch + '&type=1' : SearchPer == 2 ? '&month=' + SelectedMonth + '&type=2' : SearchPer == 3 ? '&date_start=' + DateStart + '&date_end=' + DateEnd + '&type=3' : '': ''}`, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Auth?.token}`
        },
      });

      console.log(response);


      // console.log(response['errorCode']);
      if (response['error'] == false) {

        setTotalClients(response['data'])
        // return navigate('/')
      }



      // setLoading(false)


    } catch (error) {
      // console.error(error.message);
      // setLoading(false)

    }
  }

  const GetClientsPerCat = async (GetAllData) => {
    // setLoading(true)
    try {
      const { data: response } = await axios.post(`${process.env.REACT_APP_LOCAL_URL}/categorie/get_total_clients_per_cat?ux=1${!GetAllData ? SearchPer == 1 ? '&date=' + DateSearch + '&type=1' : SearchPer == 2 ? '&month=' + SelectedMonth + '&type=2' : SearchPer == 3 ? '&date_start=' + DateStart + '&date_end=' + DateEnd + '&type=3' : '': ''}`, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Auth?.token}`
        },
      });

      console.log(response);


      // console.log(response['errorCode']);
      if (response['error'] == false) {

        setTotalClientsPerCat(response['data'])
        // return navigate('/')
      }



      // setLoading(false)


    } catch (error) {
      // console.error(error.message);
      // setLoading(false)

    }
  }


  const [Top3, setTop3] = useState([])
  const GetTop3Agents = async (GetAllData) => {
    // setLoading(true)
    try {
      const { data: response } = await axios.post(`${process.env.REACT_APP_LOCAL_URL}/categorie/get_top_agents${DateSearch && !GetAllData ? '?date_start='+DateSearch : ''}`, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Auth?.token}`
        },
      });

      console.log(response);


      // console.log(response['errorCode']);
      if (response['error'] == false) {

        setTop3(response['data'])
        // return navigate('/')
      }else{
        setTop3([])
      }



      // setLoading(false)


    } catch (error) {
      // console.error(error.message);
      // setLoading(false)

    }
  }

  const GetViewsPerDay = async () => {
    // setLoading(true)
    try {
      const { data: response } = await axios.post(`${process.env.REACT_APP_LOCAL_URL}/categorie/viewsperday`, {}, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log(response);


      // console.log(response['errorCode']);
      if (response['error'] == false) {

        setTotlaViewsPerDay(response['data'])
        // return navigate('/')
      }



      // setLoading(false)


    } catch (error) {
      // console.error(error.message);
      // setLoading(false)

    }
  }


  const GetViewsPerMonth = async () => {
    // setLoading(true)
    try {
      const { data: response } = await axios.post(`${process.env.REACT_APP_LOCAL_URL}/categorie/viewspermonth`, {}, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log(response);


      // console.log(response['errorCode']);
      if (response['error'] == false) {

        setTotlaViewsPerMonth(response['data'])
        // return navigate('/')
      }



      // setLoading(false)


    } catch (error) {
      // console.error(error.message);
      // setLoading(false)

    }
  }


  const GetMostvisitedhours = async () => {
    // setLoading(true)
    try {
      const { data: response } = await axios.post(`${process.env.REACT_APP_LOCAL_URL_Documents}/views/mostvisitedhours`, {}, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log(response);


      // console.log(response['errorCode']);
      if (response['error'] == false) {

        setMostvisitedhours(response['data'])
        // return navigate('/')
      }



      // setLoading(false)


    } catch (error) {
      // console.error(error.message);
      // setLoading(false)

    }
  }

  const GetMostvisitedDays = async () => {
    // setLoading(true)
    try {
      const { data: response } = await axios.post(`${process.env.REACT_APP_LOCAL_URL_Documents}/views/mostvisiteddays`, {}, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log(response);


      // console.log(response['errorCode']);
      if (response['error'] == false) {

        setMostvisitedDays(response['data'])
        // return navigate('/')
      }



      // setLoading(false)


    } catch (error) {
      // console.error(error.message);
      // setLoading(false)

    }
  }


  const GetWhatsAppMessages = async (GetAllData) => {
    // setLoading(true)
    try {
      const { data: response } = await axios.post(`${process.env.REACT_APP_LOCAL_URL}/categorie/get_whatsapp${DateSearch && !GetAllData ? '?date_start='+DateSearch : ''}`, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Auth?.token}`
        },
      });

      console.log(response);


      // console.log(response['errorCode']);
      if (response['error'] == false) {

        setWhatsApp(response['data'])
        // return navigate('/')
      }



      // setLoading(false)


    } catch (error) {
      // console.error(error.message);
      // setLoading(false)

    }
  }

const [AdminsStatistics, setAdminsStatistics] = useState('')
  const GetAdminsStatistics = async (GetAllData) => {
    // setLoading(true)
    try {
      const { data: response } = await axios.post(`${process.env.REACT_APP_LOCAL_URL}/categorie/get_admins_statistics?ux=1${!GetAllData ? SearchPer == 1 ? '&date=' + DateSearch + '&type=1' : SearchPer == 2 ? '&month=' + SelectedMonth + '&type=2' : SearchPer == 3 ? '&date_start=' + DateStart + '&date_end=' + DateEnd + '&type=3' : '': ''}`, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Auth?.token}`
        },
      });

      console.log(response);


      // console.log(response['errorCode']);
      if (response['error'] == false) {

        setAdminsStatistics(response['data'])
        // return navigate('/')
      }



      // setLoading(false)


    } catch (error) {
      // console.error(error.message);
      // setLoading(false)

    }
  }

  useEffect(() => {
    // setLoading(true)

    // ValidateToken();
    // GetClientsPerCat();
    GetViewsPerDay();
    GetViewsPerMonth();
    // GetTop3Agents();
    // GetMostvisitedhours();
    // GetMostvisitedDays();

  }, [])


  useEffect(() => {
    ValidateToken();
    GetAdminsStatistics();
    GetClientsPerCat();
    GetTop3Agents();
    GetWhatsAppMessages();


  
  }, [])

  function SearchFilter(GetAllData) {

    if (GetAllData) {
      setDateSearch('')
    }
    ValidateToken(GetAllData);
    GetClientsPerCat(GetAllData);
    GetAdminsStatistics(GetAllData);
    GetTop3Agents(GetAllData);
    GetWhatsAppMessages(GetAllData);

  }



  const [SearchPer, setSearchPer] = useState("1")

  const Months = [
    { name: 'Décembre 2025', value: '12-2025', year: 2025 },
    { name: 'Novembre 2025', value: '11-2025', year: 2025 },
    { name: 'Octobre 2025', value: '10-2025', year: 2025 },
    { name: 'Septembre 2025', value: '09-2025', year: 2025 },
    { name: 'Août 2025', value: '08-2025', year: 2025 },
    { name: 'Juillet 2025', value: '07-2025', year: 2025 },
    { name: 'Juin 2025', value: '06-2025', year: 2025 },
    { name: 'Mai 2025', value: '05-2025', year: 2025 },
        { name: 'Avril 2025', value: '04-2025', year: 2025 },
    { name: 'Mars 2025', value: '03-2025', year: 2025 },
    { name: 'Février 2025', value: "02-2025", year: 2025 },
    { name: 'Janvier 2025', value: "01-2025", year: 2025 },
    { name: 'Décembre 2024', value: "12-2024", year: 2024 },
    { name: 'Novembre 2024', value: "11-2024", year: 2024 },
    { name: 'Octobre 2024', value: "10-2024", year: 2024 },
    { name: 'Septembre 2024', value: "09-2024", year: 2024 },
    { name: 'Août 2024', value: "08-2024", year: 2024 },
    { name: 'Juillet 2024', value: "07-2024", year: 2024 },
    { name: 'Juin 2024', value: "06-2024", year: 2024 },
    { name: 'Mai 2024', value: "05-2024", year: 2024 },
    { name: 'Avril 2024', value: "04-2024", year: 2024 },
    { name: 'Mars 2024', value: "03-2024", year: 2024 },
    { name: 'Février 2024', value: "02-2024", year: 2024 },
    { name: 'Janvier 2024', value: "01-2024", year: 2024 }

    // { name: 'Septembre 2024', value: 9, year: 2024 },
    // { name: 'Août 2024', value: 8, year: 2024 },
    // { name: 'Juillet 2024', value: 7, year: 2024 },
    // { name: 'Juin 2024', value: 6, year: 2024 },
    // { name: 'Mai 2024', value: 5, year: 2024 },
    // { name: 'Avril 2024', value: 4, year: 2024 },
    // { name: 'Mars 2024', value: 3, year: 2024 },
    // { name: 'Février 2024', value: 2, year: 2024 },
    // { name: 'Janvier 2024', value: 1, year: 2024 }
  ];

  const [SelectedMonth, setSelectedMonth] = useState("")

  const [DateStart, setDateStart] = useState("");
  const [DateEnd, setDateEnd] = useState("");


  

  return (
    <div className='dashboard'>


      <div className=''>
        <div className=''>

          <Menu MenuShow={MenuShow} setMenuShow={setMenuShow} />

        </div>
        <div className='page-client pt-lg-5' style={{ marginLeft: windowSize.innerWidth > 992 ? (MenuShow == true ? '328px' : '89px') : '0px' }}>
          <div className='menu-mobile-section'>
            <svg onClick={() => setMenuShow((p) => !p)} xmlns="http://www.w3.org/2000/svg" width="22.575" height="22.453" viewBox="0 0 22.575 22.453">
              <g id="Groupe_429" data-name="Groupe 429" transform="translate(-177.5 120.5)">
                <line id="Ligne_82" data-name="Ligne 82" x2="22.575" transform="translate(177.5 -119.5)" fill="none" stroke="#fff" stroke-width="2" />
                <line id="Ligne_83" data-name="Ligne 83" x2="22.575" transform="translate(177.5 -109.273)" fill="none" stroke="#fff" stroke-width="2" />
                <line id="Ligne_84" data-name="Ligne 84" x2="22.575" transform="translate(177.5 -99.047)" fill="none" stroke="#fff" stroke-width="2" />
              </g>
            </svg>
          </div>
          <div className='page-title'>Application <span>Commandes</span></div>
          <div className='client-information mt-5'>
            <div className='container'>

            <div className='container-etat'>
                <div className={`btn-etat ${SearchPer == 1 ? "btn-etat-active" : ""}`} onClick={(e) => setSearchPer(1)}>Par Jour</div>
                <div className={`btn-etat ${SearchPer == 3 ? "btn-etat-active" : ""}`} onClick={(e) => setSearchPer(3)}>Par Semaine</div>

                <div className={`btn-etat ${SearchPer == 2 ? "btn-etat-active" : ""}`} onClick={(e) => setSearchPer(2)}>Par Mois</div>

              </div>

              {SearchPer == 1 ? <div className='d-flex justify-content-center mt-2 mb-4 flex-wrap align-items-end'>
                {/* {DateSearch ? <div className="x me-2" onClick={()=> SearchFilter(true)}>
                X
              </div> : ''} */}
                <div className='me-2' style={{ width: '180px' }}>
                  <label style={{ fontSize: '13px' }}>Par Date</label>

                  <input type="date" onChange={(e) => setDateSearch(e.target.value)} value={DateSearch} className="form-control me-3" id="inputEmail4" />
                </div>
                {/* <div style={{ width: '180px' }}>
                                    <label style={{ fontSize: '13px' }}>Date de fin</label>

                                    <input type="date" onChange={(e) => setDonwloadDateEnd(e.target.value)} value={DonwloadDateEnd} className="form-control me-3" id="inputEmail4" />
                                </div> */}
                <div className='search-btn-dashboard' onClick={() => SearchFilter()}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="30.621" height="30.621" viewBox="0 0 30.621 30.621">
                    <g id="Icon_feather-search" data-name="Icon feather-search" transform="translate(1.5 1.5)">
                      <path id="Tracé_1" data-name="Tracé 1" d="M28.5,16.5a12,12,0,1,1-12-12,12,12,0,0,1,12,12Z" transform="translate(-4.5 -4.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" />
                      <path id="Tracé_2" data-name="Tracé 2" d="M31.5,31.5l-6.525-6.525" transform="translate(-4.5 -4.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" />
                    </g>
                  </svg>


                </div>
              </div> : ""}


              {SearchPer == 2 ?
                <div className='d-flex justify-content-center mt-2 mb-4 flex-wrap align-items-center'>
                  <div className="mb-3 mt-1 me-3">
                    {/* <input type="text" onChange={(e) => setActedenaissance(e.target.value.replace(/[^0-9]+/g , ''))} value={Actedenaissance} className="form-control me-2" id="inputPassword4" /> */}
                    <label style={{ fontSize: '13px' }}>Par Mois</label>
                    <select style={{ maxWidth: "300px" }} class="form-select" aria-label="Default select example" onChange={(e) => setSelectedMonth(e.target.value)}>
                      <option disabled selected={SelectedMonth == ''}>Veuillez sélectionner le Mois</option>
                      {Months?.length > 0 && Months?.map((item, i) => (
                        <option selected={SelectedMonth == item?.value} value={item?.value}>{item?.name}</option>
                      ))
                      }
                    </select>
                    {/* <div className='err-cart-sum'>{Showerrors && errors?.Motif !== '' ? errors?.Motif : ''}</div> */}
                  </div>
                  <div className='search-btn-dashboard' onClick={() => SelectedMonth ? SearchFilter() : ""}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30.621" height="30.621" viewBox="0 0 30.621 30.621">
                      <g id="Icon_feather-search" data-name="Icon feather-search" transform="translate(1.5 1.5)">
                        <path id="Tracé_1" data-name="Tracé 1" d="M28.5,16.5a12,12,0,1,1-12-12,12,12,0,0,1,12,12Z" transform="translate(-4.5 -4.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" />
                        <path id="Tracé_2" data-name="Tracé 2" d="M31.5,31.5l-6.525-6.525" transform="translate(-4.5 -4.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" />
                      </g>
                    </svg>


                  </div>
                </div> : ""}

                {SearchPer == 3 ? <div className='d-flex justify-content-center mt-2 mb-4 flex-wrap align-items-end'>
                        {/* {DateSearch ? <div className="x me-2" onClick={()=> SearchFilter(true)}>
                X
              </div> : ''} */}
                        <div className='me-2' style={{ width: '180px' }}>
                            <label style={{ fontSize: '13px' }}>Date de début</label>
                            <input type="date" onChange={(e) => setDateStart(e.target.value)} value={DateStart} className="form-control me-3" id="inputEmail4" />
                        </div>

                        <div className='me-2' style={{ width: '180px' }}>
                            <label style={{ fontSize: '13px' }}>Date de fin</label>
                            <input type="date" onChange={(e) => setDateEnd(e.target.value)} value={DateEnd} className="form-control me-3" id="inputEmail4" />
                        </div>
                        {/* <div style={{ width: '180px' }}>
                                    <label style={{ fontSize: '13px' }}>Date de fin</label>

                                    <input type="date" onChange={(e) => setDonwloadDateEnd(e.target.value)} value={DonwloadDateEnd} className="form-control me-3" id="inputEmail4" />
                                </div> */}
                        <div className='search-btn-dashboard' onClick={() => SearchFilter()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="30.621" height="30.621" viewBox="0 0 30.621 30.621">
                                <g id="Icon_feather-search" data-name="Icon feather-search" transform="translate(1.5 1.5)">
                                    <path id="Tracé_1" data-name="Tracé 1" d="M28.5,16.5a12,12,0,1,1-12-12,12,12,0,0,1,12,12Z" transform="translate(-4.5 -4.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" />
                                    <path id="Tracé_2" data-name="Tracé 2" d="M31.5,31.5l-6.525-6.525" transform="translate(-4.5 -4.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" />
                                </g>
                            </svg>


                        </div>
                    </div> : ""}


            {/* <div className='d-flex justify-content-center mt-2 mb-4 flex-wrap align-items-end'>
              {DateSearch ? <div className="x me-2" onClick={()=> SearchFilter(true)}>
                X
              </div> : ''}
                                <div className='me-2' style={{ width: '180px' }}>
                                    <label style={{ fontSize: '13px' }}>Par Date</label>

                                    <input type="date" onChange={(e) => setDateSearch(e.target.value)} value={DateSearch} className="form-control me-3" id="inputEmail4" />
                                </div>
                              
                                <div className='search-btn-dashboard' onClick={()=> SearchFilter()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="30.621" height="30.621" viewBox="0 0 30.621 30.621">
                                <g id="Icon_feather-search" data-name="Icon feather-search" transform="translate(1.5 1.5)">
                                    <path id="Tracé_1" data-name="Tracé 1" d="M28.5,16.5a12,12,0,1,1-12-12,12,12,0,0,1,12,12Z" transform="translate(-4.5 -4.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" />
                                    <path id="Tracé_2" data-name="Tracé 2" d="M31.5,31.5l-6.525-6.525" transform="translate(-4.5 -4.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" />
                                </g>
                            </svg>


                        </div>
                            </div> */}
              <div className='row'>
                <div className='col-12 col-lg-4 gy-5 gy-lg-0'>
                  <div className='box-info bg-g-first'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24.631" height="24.631" viewBox="0 0 24.631 24.631">
                      <path id="Tracé_6" data-name="Tracé 6" d="M23.028,27.063H3.6A2.6,2.6,0,0,1,1,24.46V11.6A2.6,2.6,0,0,1,3.6,9H23.028a2.6,2.6,0,0,1,2.6,2.6V24.46A2.6,2.6,0,0,1,23.028,27.063ZM3.6,10.642a.961.961,0,0,0-.961.961V24.46a.961.961,0,0,0,.961.961H23.028a.961.961,0,0,0,.961-.961V11.6a.961.961,0,0,0-.961-.961Z" transform="translate(-1 -2.432)" fill="#fff" />
                      <rect id="Rectangle_4" data-name="Rectangle 4" width="16" height="2" rx="1" transform="translate(4 3)" fill="#fff" />
                      <rect id="Rectangle_5" data-name="Rectangle 5" width="12" height="2" rx="1" transform="translate(6)" fill="#fff" />
                      <path id="Tracé_7" data-name="Tracé 7" d="M16.039,15.708H14.4a2.775,2.775,0,0,1-2.767-2.767V9h7.184v3.933a2.775,2.775,0,0,1-2.775,2.775Zm-2.767-5.066v2.291A1.133,1.133,0,0,0,14.4,14.066h1.642a1.133,1.133,0,0,0,1.133-1.125v-2.3Z" transform="translate(-2.902 -2.432)" fill="#fff" />
                    </svg>

                    <p>Nombre de commandes</p>
                    <p>{TotalClients && TotalClients?.total ? TotalClients?.total : 0}</p>
                  </div>
                </div>
                <div className='col-12 col-lg-4 gy-5 gy-lg-0'>
                  <div className='box-info bg-g-second'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <g id="Union_5" data-name="Union 5" fill="none" stroke-linejoin="round">
                        <path d="M13.2,24V13.2H24V24ZM0,24V13.2H10.8V24ZM13.2,10.8V0H24V10.8ZM0,10.8V0H10.8V10.8Z" stroke="none" />
                        <path d="M 22.10000038146973 22.10000038146973 L 22.10000038146973 15.09988975524902 L 15.09988975524902 15.09988975524902 L 15.09988975524902 22.10000038146973 L 22.10000038146973 22.10000038146973 M 8.900110244750977 22.10000038146973 L 8.900110244750977 15.09988975524902 L 1.899999976158142 15.09988975524902 L 1.899999976158142 22.10000038146973 L 8.900110244750977 22.10000038146973 M 22.10000038146973 8.900110244750977 L 22.10000038146973 1.899999976158142 L 15.09988975524902 1.899999976158142 L 15.09988975524902 8.900110244750977 L 22.10000038146973 8.900110244750977 M 8.900110244750977 8.900110244750977 L 8.900110244750977 1.899999976158142 L 1.899999976158142 1.899999976158142 L 1.899999976158142 8.900110244750977 L 8.900110244750977 8.900110244750977 M 24 24 L 13.19989013671875 24 L 13.19989013671875 13.19989013671875 L 24 13.19989013671875 L 24 24 Z M 10.80010986328125 24 L -1.77635683940025e-15 24 L -1.77635683940025e-15 13.19989013671875 L 10.80010986328125 13.19989013671875 L 10.80010986328125 24 Z M 24 10.80010986328125 L 13.19989013671875 10.80010986328125 L 13.19989013671875 -1.77635683940025e-15 L 24 -1.77635683940025e-15 L 24 10.80010986328125 Z M 10.80010986328125 10.80010986328125 L -1.77635683940025e-15 10.80010986328125 L -1.77635683940025e-15 -1.77635683940025e-15 L 10.80010986328125 -1.77635683940025e-15 L 10.80010986328125 10.80010986328125 Z" stroke="none" fill="#fff" />
                      </g>
                    </svg>

                    <p>En attente</p>
                    <p>{TotalClients && TotalClients?.waiting ? TotalClients?.waiting : 0}</p>
                  </div>
                </div>
                <div className='col-12 col-lg-4 gy-5 gy-lg-0'>
                  <div className='box-info bg-g-third'>
                    <svg id="dashboard-svgrepo-com" xmlns="http://www.w3.org/2000/svg" width="30.776" height="25.646" viewBox="0 0 30.776 25.646">
                      <g id="Groupe_431" data-name="Groupe 431">
                        <g id="Groupe_430" data-name="Groupe 430">
                          <path id="Tracé_9269" data-name="Tracé 9269" d="M15.388,2.334h0A15.339,15.339,0,0,0,4.51,6.838l0,0,0,0A15.339,15.339,0,0,0,0,17.708s0,.009,0,.014,0,.009,0,.013a15.326,15.326,0,0,0,3.517,9.78,1.282,1.282,0,0,0,.989.466H26.269a1.282,1.282,0,0,0,.989-.466A15.387,15.387,0,0,0,15.388,2.334ZM25.647,25.415H5.128A12.742,12.742,0,0,1,2.629,19H6.412a1.282,1.282,0,1,0,0-2.565H2.629A12.763,12.763,0,0,1,5.459,9.606l.861.861A1.282,1.282,0,0,0,8.134,8.654l-.861-.861a12.763,12.763,0,0,1,6.833-2.831V8.745a1.282,1.282,0,0,0,2.565,0V4.962A12.763,12.763,0,0,1,23.5,7.793l-.861.861a1.282,1.282,0,1,0,1.813,1.813l.861-.861a12.763,12.763,0,0,1,2.831,6.833H24.364a1.282,1.282,0,0,0,0,2.565h3.784A12.743,12.743,0,0,1,25.647,25.415Z" transform="translate(0 -2.334)" fill="#fff" />
                          <path id="Tracé_9270" data-name="Tracé 9270" d="M18.153,12.067,10.9,15.695l3.626,3.626Z" transform="translate(1.081 -1.369)" fill="#fff" />
                          <path id="Tracé_9271" data-name="Tracé 9271" d="M18.309,19.833H10.615a1.282,1.282,0,1,0,0,2.565h7.694a1.282,1.282,0,0,0,0-2.565Z" transform="translate(0.925 -0.599)" fill="#fff" />
                        </g>
                      </g>
                    </svg>


                    <p >Confirmer</p>
                    <p>{TotalClients && TotalClients?.Confirmer ? TotalClients?.Confirmer : 0}</p>
                  </div>
                </div>

                <div className='col-12 col-lg-4 gy-5 gy-lg-0 mt-4'>
                  <div className='box-info' style={{ background: 'linear-gradient(45deg, #9490c0, #6d8cff)' }}>
                    <svg id="dashboard-svgrepo-com" xmlns="http://www.w3.org/2000/svg" width="30.776" height="25.646" viewBox="0 0 30.776 25.646">
                      <g id="Groupe_431" data-name="Groupe 431">
                        <g id="Groupe_430" data-name="Groupe 430">
                          <path id="Tracé_9269" data-name="Tracé 9269" d="M15.388,2.334h0A15.339,15.339,0,0,0,4.51,6.838l0,0,0,0A15.339,15.339,0,0,0,0,17.708s0,.009,0,.014,0,.009,0,.013a15.326,15.326,0,0,0,3.517,9.78,1.282,1.282,0,0,0,.989.466H26.269a1.282,1.282,0,0,0,.989-.466A15.387,15.387,0,0,0,15.388,2.334ZM25.647,25.415H5.128A12.742,12.742,0,0,1,2.629,19H6.412a1.282,1.282,0,1,0,0-2.565H2.629A12.763,12.763,0,0,1,5.459,9.606l.861.861A1.282,1.282,0,0,0,8.134,8.654l-.861-.861a12.763,12.763,0,0,1,6.833-2.831V8.745a1.282,1.282,0,0,0,2.565,0V4.962A12.763,12.763,0,0,1,23.5,7.793l-.861.861a1.282,1.282,0,1,0,1.813,1.813l.861-.861a12.763,12.763,0,0,1,2.831,6.833H24.364a1.282,1.282,0,0,0,0,2.565h3.784A12.743,12.743,0,0,1,25.647,25.415Z" transform="translate(0 -2.334)" fill="#fff" />
                          <path id="Tracé_9270" data-name="Tracé 9270" d="M18.153,12.067,10.9,15.695l3.626,3.626Z" transform="translate(1.081 -1.369)" fill="#fff" />
                          <path id="Tracé_9271" data-name="Tracé 9271" d="M18.309,19.833H10.615a1.282,1.282,0,1,0,0,2.565h7.694a1.282,1.282,0,0,0,0-2.565Z" transform="translate(0.925 -0.599)" fill="#fff" />
                        </g>
                      </g>
                    </svg>


                    <p >Annuler</p>
                    <p>{TotalClients && TotalClients?.Annuler ? TotalClients?.Annuler : 0}</p>
                  </div>
                </div>

                <div className='col-12 col-lg-4 gy-5 gy-lg-0 mt-4'>
                  <div className='box-info' style={{ background: 'linear-gradient(161deg, #abafae, #8d8d8d)' }}>
                    <svg id="dashboard-svgrepo-com" xmlns="http://www.w3.org/2000/svg" width="30.776" height="25.646" viewBox="0 0 30.776 25.646">
                      <g id="Groupe_431" data-name="Groupe 431">
                        <g id="Groupe_430" data-name="Groupe 430">
                          <path id="Tracé_9269" data-name="Tracé 9269" d="M15.388,2.334h0A15.339,15.339,0,0,0,4.51,6.838l0,0,0,0A15.339,15.339,0,0,0,0,17.708s0,.009,0,.014,0,.009,0,.013a15.326,15.326,0,0,0,3.517,9.78,1.282,1.282,0,0,0,.989.466H26.269a1.282,1.282,0,0,0,.989-.466A15.387,15.387,0,0,0,15.388,2.334ZM25.647,25.415H5.128A12.742,12.742,0,0,1,2.629,19H6.412a1.282,1.282,0,1,0,0-2.565H2.629A12.763,12.763,0,0,1,5.459,9.606l.861.861A1.282,1.282,0,0,0,8.134,8.654l-.861-.861a12.763,12.763,0,0,1,6.833-2.831V8.745a1.282,1.282,0,0,0,2.565,0V4.962A12.763,12.763,0,0,1,23.5,7.793l-.861.861a1.282,1.282,0,1,0,1.813,1.813l.861-.861a12.763,12.763,0,0,1,2.831,6.833H24.364a1.282,1.282,0,0,0,0,2.565h3.784A12.743,12.743,0,0,1,25.647,25.415Z" transform="translate(0 -2.334)" fill="#fff" />
                          <path id="Tracé_9270" data-name="Tracé 9270" d="M18.153,12.067,10.9,15.695l3.626,3.626Z" transform="translate(1.081 -1.369)" fill="#fff" />
                          <path id="Tracé_9271" data-name="Tracé 9271" d="M18.309,19.833H10.615a1.282,1.282,0,1,0,0,2.565h7.694a1.282,1.282,0,0,0,0-2.565Z" transform="translate(0.925 -0.599)" fill="#fff" />
                        </g>
                      </g>
                    </svg>


                    <p >Tentative échouée</p>
                    <p>{TotalClients && TotalClients?.Tentative_échouée ? TotalClients?.Tentative_échouée : 0}</p>
                  </div>
                </div>

                {/* <div className='col-12 col-lg-4 gy-5 gy-lg-0 mt-4'>
                  <div className='box-info'  style={{background : 'linear-gradient(45deg, #3a87d9, #2fb382)'}}>
                  <svg className='mb-1' id="dashboard-svgrepo-com" xmlns="http://www.w3.org/2000/svg" width="30.776" height="25.646" viewBox="0 0 30.776 25.646">
                    <g id="Groupe_431" data-name="Groupe 431">
                      <g id="Groupe_430" data-name="Groupe 430">
                        <path id="Tracé_9269" data-name="Tracé 9269" d="M15.388,2.334h0A15.339,15.339,0,0,0,4.51,6.838l0,0,0,0A15.339,15.339,0,0,0,0,17.708s0,.009,0,.014,0,.009,0,.013a15.326,15.326,0,0,0,3.517,9.78,1.282,1.282,0,0,0,.989.466H26.269a1.282,1.282,0,0,0,.989-.466A15.387,15.387,0,0,0,15.388,2.334ZM25.647,25.415H5.128A12.742,12.742,0,0,1,2.629,19H6.412a1.282,1.282,0,1,0,0-2.565H2.629A12.763,12.763,0,0,1,5.459,9.606l.861.861A1.282,1.282,0,0,0,8.134,8.654l-.861-.861a12.763,12.763,0,0,1,6.833-2.831V8.745a1.282,1.282,0,0,0,2.565,0V4.962A12.763,12.763,0,0,1,23.5,7.793l-.861.861a1.282,1.282,0,1,0,1.813,1.813l.861-.861a12.763,12.763,0,0,1,2.831,6.833H24.364a1.282,1.282,0,0,0,0,2.565h3.784A12.743,12.743,0,0,1,25.647,25.415Z" transform="translate(0 -2.334)" fill="#fff"/>
                        <path id="Tracé_9270" data-name="Tracé 9270" d="M18.153,12.067,10.9,15.695l3.626,3.626Z" transform="translate(1.081 -1.369)" fill="#fff"/>
                        <path id="Tracé_9271" data-name="Tracé 9271" d="M18.309,19.833H10.615a1.282,1.282,0,1,0,0,2.565h7.694a1.282,1.282,0,0,0,0-2.565Z" transform="translate(0.925 -0.599)" fill="#fff"/>
                      </g>
                    </g>
                  </svg>


                     <p className='mb-1' style={{fontSize :"15px"}} >Demandes au niveau de la banque</p>
                     <p className='mb-0'>{TotalClients && TotalClients?.vu_bank  ?  TotalClients?.vu_bank : 0}</p>
                     <p className='mb-0' style={{lineHeight : "1"}}><span className='dashboard-span me-1'><b> En attente : {TotalClients && TotalClients?.waiting_bank   ?  TotalClients?.waiting_bank  : 0}</b></span> <span className='dashboard-span me-1'> <b>Validé : {TotalClients && TotalClients?.valid_bank   ?  TotalClients?.valid_bank  : 0}</b> </span> <span className='dashboard-span' ><b>Rejeté :{TotalClients && TotalClients?.rejected_bank   ?  TotalClients?.rejected_bank  : 0} </b></span></p>
                  </div>
              </div> */}







              </div>
            </div>
          </div>
          <div className="container mt-5">

            <div className="analytic-boxes">




              <div className="analytic-box">
                <h5><b>Nombre de commandes</b></h5>
                <div>
                  <p className="mb-0 pb-0">Moto : {TotalClientsPerCat && TotalClientsPerCat?.total_moto ? TotalClientsPerCat?.total_moto : 0}</p>
                  <p className="mb-0 pb-0">Électroménager : {TotalClientsPerCat && TotalClientsPerCat?.total_electro ? TotalClientsPerCat?.total_electro : 0}</p>
                </div>
              </div>

              <div className="analytic-box">
                <h5><b>En attente</b></h5>
                <div>
                  <p className="mb-0 pb-0">Moto : {TotalClientsPerCat && TotalClientsPerCat?.waiting_moto ? TotalClientsPerCat?.waiting_moto : 0}</p>
                  <p className="mb-0 pb-0">Électroménager : {TotalClientsPerCat && TotalClientsPerCat?.waiting_electro ? TotalClientsPerCat?.waiting_electro : 0}</p>
                </div>
              </div>

              <div className="analytic-box">
                <h5><b>Confirmer</b></h5>
                <div>
                  <p className="mb-0 pb-0">Moto : {TotalClientsPerCat && TotalClientsPerCat?.Confirmer_moto ? TotalClientsPerCat?.Confirmer_moto : 0}</p>
                  <p className="mb-0 pb-0">Électroménager : {TotalClientsPerCat && TotalClientsPerCat?.Confirmer_electro ? TotalClientsPerCat?.Confirmer_electro : 0}</p>
                </div>
              </div>

              <div className="analytic-box">
                <h5><b>Tentative échouée</b></h5>
                <div>
                  <p className="mb-0 pb-0">Moto : {TotalClientsPerCat && TotalClientsPerCat?.Tentative_échouée_moto ? TotalClientsPerCat?.Tentative_échouée_moto : 0}</p>
                  <p className="mb-0 pb-0">Électroménager : {TotalClientsPerCat && TotalClientsPerCat?.Tentative_échouée_electro ? TotalClientsPerCat?.Tentative_échouée_electro : 0}</p>
                </div>
              </div>

              <div className="analytic-box">
                <h5><b>Annuler</b></h5>
                <div>
                  <p className="mb-0 pb-0">Moto : {TotalClientsPerCat && TotalClientsPerCat?.Annuler_moto ? TotalClientsPerCat?.Annuler_moto : 0}</p>
                  <p className="mb-0 pb-0">Électroménager : {TotalClientsPerCat && TotalClientsPerCat?.Annuler_electro ? TotalClientsPerCat?.Annuler_electro : 0}</p>
                </div>
              </div>

              <div className="analytic-box">
                <h5><b>Secteur d’activité</b></h5>
                <div>
                  <p className="mb-0 pb-0">Salarié (Public) : {TotalClientsPerCat && TotalClientsPerCat?.public ? TotalClientsPerCat?.public : 0}</p>
                  <p className="mb-0 pb-0">Salarié (Privé) : {TotalClientsPerCat && TotalClientsPerCat?.prive ? TotalClientsPerCat?.prive : 0}</p>
                  <p className="mb-0 pb-0">Retraité : {TotalClientsPerCat && TotalClientsPerCat?.retraite ? TotalClientsPerCat?.retraite : 0}</p>
                  <p className="mb-0 pb-0">Commerçant : {TotalClientsPerCat && TotalClientsPerCat?.commercant ? TotalClientsPerCat?.commercant : 0}</p>
                  <p className="mb-0 pb-0">Chômeur : {TotalClientsPerCat && TotalClientsPerCat?.chomeur ? TotalClientsPerCat?.chomeur : 0}</p>

                </div>
              </div>

              {/* <div className="analytic-box">
                <h5><b>WhatsApp Messages</b></h5>
                <div>
                <p className="mb-0 pb-0">Total : {WhatsApp && WhatsApp?.total ? WhatsApp?.total : 0}</p>
                  <p className="mb-0 pb-0">Salarié (Public) : {WhatsApp && WhatsApp?.public ? WhatsApp?.public : 0}</p>
                  <p className="mb-0 pb-0">Salarié (Privé) : {WhatsApp && WhatsApp?.prive ? WhatsApp?.prive : 0}</p>
                  <p className="mb-0 pb-0">Retraité : {WhatsApp && WhatsApp?.retraite ? WhatsApp?.retraite : 0}</p>
                  <p className="mb-0 pb-0">Commerçant : {WhatsApp && WhatsApp?.commercant ? WhatsApp?.commercant : 0}</p>
                  <p className="mb-0 pb-0">Chômeur : {WhatsApp && WhatsApp?.chomeur ? WhatsApp?.chomeur : 0}</p>


                </div>
              </div> */}


             
              

              {/* <div className="analytic-box">
                <h5><b>Top 5 (Agents)</b></h5>
                <div>

                  {Top3?.length > 0 && Top3?.map((item, i) => (
                    <p className="mb-0 pb-0">👩🏻<b>{item?.admin_name_action}</b> -  Confirmées ({item?.Total})</p>
                  ))
                  }

                </div>
              </div> */}

            </div>
          </div>
          
          <div className="container mt-5">
          <div
          className="titel-chart mb-4 mt-5"
          style={{ background: "linear-gradient(45deg, rgb(135 135 135), rgb(46 46 46))" }}
        >
          <i className="fas fa-desktop" />
          <p className="mb-0 ms-3">Admin Statistics</p>
        </div>
          <div className="analytic-boxes">
      {AdminsStatistics?.length > 0 ? (
        AdminsStatistics?.map((admin, index) => (
          <div key={index} className="analytic-box">
            <h5><b>{admin["Admin Name"]}</b></h5>
            <div>
              {Object.entries(admin).map(([key, value]) => (
                key !== 'Admin ID' && key !== 'Admin Name' ? ( // Skip Admin ID and Admin Name
                  <div key={key}>
                    <strong>{key}:</strong> {value}
                  </div>
                ) : null
              ))}
            </div>
          </div>
        ))
      ) : (
        <p>Loading data...</p>
      )}
    </div>
    </div>

          

          <div className='page-content'>



            <div
              className="titel-chart"
              style={{ background: "linear-gradient(45deg, #feb6b0, #fe7199)" }}
            >
              <i className="fas fa-desktop" />
              <p className="mb-0 ms-3">Commandes Par Jour</p>
            </div>
            <div className="data-state">
              <div className="day">
                <div className="day-d">
                  <span className="color-r" />
                  Aujourd'hui : {TotlaViewsPerDay?.today}
                </div>
                <div className="day-d">
                  <span className="color-r" />
                  Hier : {TotlaViewsPerDay?._1day}
                </div>
                <div className="day-d">
                  <span className="color-r" />
                  Avant-hier : {TotlaViewsPerDay?._2day}
                </div>
              </div>
            </div>
            <div className='m-auto text-center chart-iamal' style={{ width: '100%', height: '400px' }}>
              <Line options={options} data={data} className="m-auto" style={{ width: '100%', height: '400px' }} />
            </div>


            <div className="titel-chart mt-5">
              <i className="far fa-chart-bar" />
              <p className="mb-0 ms-3">Commandes Par Mois</p>
            </div>

            <div className="data-state">
              <div className="month">
                {/*?php 
$mois = array("","Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"); 
// echo $mois[date('n', strtotime('07-'.$months))];
?*/}
                <div className="day-d">
                  <span className="color-b" />
                  {monthtodayFormat + " (" + TotlaViewsPerMonth?.Months + " commandes )" /*?php echo $mois[date('n', strtotime('03-'.$months))] .' : '. $month_data; ?*/}
                </div>
                <div className="day-d">
                  <span className="color-b" />
                  {month1Format + " (" + TotlaViewsPerMonth?.Months_1 + " commandes )" /*?php echo $mois[date('n', strtotime('03-'.$months_1))] .' : '. $month_data1; ?*/}
                </div>
                <div className="day-d">
                  <span className="color-b" />
                  {month2Format + " (" + TotlaViewsPerMonth?.Months_2 + " commandes )" /*?php echo $mois[date('n', strtotime('03-'.$months_2))] .' : '. $month_data2; ?*/}
                </div>
              </div>
            </div>

            <div className='m-auto text-center chart-iamal' style={{ width: '100%', height: '400px' }}>
              <Bar options={optionstwo} data={data2} className="m-auto" style={{ height: '400px' }} />
            </div>





          </div>
        </div>
      </div>

    </div>
  )
}

export default Application